import angular from 'angular';

class batchDetailsCtrl {
    /* @ngInject */
    constructor($scope, CONF, BatchService, Files, $window, AuthSvc, $uibModal) {
        this.$scope = $scope;
        this.CONF = CONF;
        this.BatchService = BatchService;
        this.Files = Files;
        this.$window = $window;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        // Accès raccourcis aux autorisations depuis le scope principal
        this.isAuthorized = this.AuthSvc.isAuthorized;

        this.includes = {
            batch: require('./batch-tab.html'),
            index: require('./index-tab.html'),
        };

        this.ladProviderBatchDetailsUrl = null;

        this.batch.$promise.then(() => this._initLadProviderBatchDetailsUrl());
    }

    // Permet de télécharger un fichier index
    openCsvFIle(fileId, fileType) {
        return this.Files.downloadIndexFile(fileId, fileType);
    }

    openPdfFIle(fileId) {
        return this.Files.download(fileId);
    }

    getDeliverable() {
        return this.BatchService.getDeliverable(this.batch.batchId);
    }

    goBack() {
        this.$window.history.back();
    }

    /**
     * Retourne True si le lot a été envoyé au prestataire et que l'utilisateur a le role SUPPORT.
     */
    showReject102Button() {
        return (
            !this.isZedocLad() && 
            this.isAuthorized('SUPPORT') &&
            (this.batch.batchStatus === 'SENT_TO_PRESTA' || this.batch.batchStatus === 'AVAILABLE')
        );
    }

    /**
     * Affiche une modal permettant le rejet du lot.
     */
    rejectBatch102() {
        this.$uibModal
            .open({
                component: 'rejectBatch102Modal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(reason => {
                const criteria = {
                    batchIds: [this.batch.batchId],
                    motif: reason,
                    errorCode: 102,
                };
                this.BatchService.reject102(criteria, () => {
                    document.location.reload(true);
                });
            }, this.dismissModal);
    }

    dismissModal(/*reason*/) {}

    _initLadProviderBatchDetailsUrl() {
        if (this.isZedocLad()) {
            // Pas terrible ce test sur le nom du prestataire !
            var url =
                this.CONF.apiContext + this.CONF.proxyZeDoc + '/api/v1/requests/channel/epdf/' + this.batch.batchId;
            this.ladProviderBatchDetailsUrl = url;
        }
    }

    isZedocLad() {
        return this.batch.ladProviderName === 'Zedoc';
    }
}

angular.module('dashboard').component('batchDetails', {
    templateUrl: require('./batch-details.html'),
    controller: batchDetailsCtrl,
    bindings: {
        batch: '<',
        activeTabName: '<',
    },
});
